import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { GridDataResult } from '@progress/kendo-angular-grid';
import { Observable } from 'rxjs';
import { toDataSourceRequestString } from '@progress/kendo-data-query';
import { GridState } from '@shared';

export interface RevenueCenter {
  id: number;
  name: string;
}

@Injectable({
  providedIn: 'root',
})
export class RevenueCenterService {
  private apiUrl: string = environment.apiUrl + '/revenue-centers';

  constructor(private httpClient: HttpClient) {}

  getAllRevenueCenters(state: GridState): Observable<GridDataResult> {
    return this.httpClient.get<GridDataResult>(
      `${this.apiUrl}?${toDataSourceRequestString(state)}`,
    );
  }
}
